var generateStyle = function generateStyle(componentTheme) {
  return {
    itemStem: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    feedbackLabel: {
      fontSize: componentTheme.feedbackLabelFontSize
    }
  };
};
export default generateStyle;